import React from "react";

import Loading from "ui/Loading";
import PageContent from "ui/PageContent";
import SettingsNav from "ui/SettingsNav";
import {
  useCurrentOrganization,
  useCurrentServerGroup,
} from "providers/WithCurrentOrganization";

import ServerGroupEdit from "features/Server/ServerGroupEdit";

import EditForm from "./EditForm";

const ServerGroupSettings = () => {
  const currentOrganization = useCurrentOrganization();
  const currentServerGroup = useCurrentServerGroup(true);
  if (currentOrganization == null || currentServerGroup == null) {
    return <Loading error />;
  }

  const customServerGroup = currentOrganization.serverGroups.find(
    (sg) => sg.id === currentServerGroup.id && sg.clusterId == null,
  );

  return (
    <PageContent
      title="Settings"
      pageCategory="servergroup"
      pageName="edit"
      featureNav={<SettingsNav />}
    >
      {customServerGroup ? (
        <ServerGroupEdit
          key={customServerGroup.id}
          serverGroup={customServerGroup}
          currentOrganization={currentOrganization}
        />
      ) : (
        <EditForm
          key={currentServerGroup.id}
          serverGroup={currentServerGroup}
          currentOrganization={currentOrganization}
        />
      )}
    </PageContent>
  );
};

export default ServerGroupSettings;
